import { Typography } from '@navi/web-ui/lib/primitives';
import styles from '../../AgentForm.module.scss';
import AgentFormTextbox from './AgentFormTextbox';
import { IAgentBaseLocationProps } from '../../interfaces/types';

const AgentBaseLocation = (props: IAgentBaseLocationProps) => {
  const {
    latitude,
    longitude,
    control,
    errors,
    isEditDisabled,
    callbackFn,
    showCurrentMonthLabel = true
  } = props;

  return (
    <div className={styles.locationContainer}>
      <div className="flex">
        <Typography variant="p4" color="var(--navi-color-gray-c2)" className="pr-1">
          {'Agent base location '}
        </Typography>
        {showCurrentMonthLabel && (
          <Typography variant="p4" color="var(--navi-color-gray-c3)">
            {'(for current month)'}
          </Typography>
        )}
      </div>
      <div className="flex">
        <AgentFormTextbox
          control={control}
          name={latitude}
          rules={{}}
          inputLabel={''}
          placeholder={'Enter here'}
          isEditDisabled={isEditDisabled}
          errors={errors}
          styles={styles}
          validationMessage={'Enter latitude value'}
          onChangeCallback={callbackFn}
        />
        <Typography
          variant="p4"
          color="var(--navi-color-gray-c2)"
          className={styles.coordinatesText}
        >
          {'Lat'}
        </Typography>
        <AgentFormTextbox
          control={control}
          name={longitude}
          rules={{}}
          inputLabel={''}
          placeholder={'Enter here'}
          isEditDisabled={isEditDisabled}
          errors={errors}
          styles={styles}
          validationMessage={'Enter longitude value'}
          onChangeCallback={callbackFn}
        />
        <Typography
          variant="p4"
          color="var(--navi-color-gray-c2)"
          className={styles.coordinatesText}
        >
          {'Long'}
        </Typography>
      </div>
    </div>
  );
};

export default AgentBaseLocation;
